import React, { ReactNode, useState } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { MobileTabBar } from './MobileTabBar';

interface DashboardLayoutProps {
  children: ReactNode;
}

const COLLAPSED_KEY = 'staketory.sidebar.collapsed';

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(COLLAPSED_KEY) === 'true';
    } catch {
      return false;
    }
  });

  const toggleCollapsed = () => {
    setCollapsed((value) => {
      try {
        localStorage.setItem(COLLAPSED_KEY, String(!value));
      } catch {}
      return !value;
    });
  };

  return (
    // app-shell defines --app-tabbar-h so fixed bottom bars can sit above the mobile tab bar
    <div className="app-shell min-h-screen bg-white lg:flex" data-testid="dashboard-layout">
      <Sidebar collapsed={collapsed} onToggleCollapsed={toggleCollapsed} />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar />
        {/* overflow-x-clip: a page wider than the phone must not widen the viewport under the fixed bars */}
        <main className="flex-1 overflow-x-clip p-4 pb-[calc(var(--app-tabbar-h)_+_1.5rem)] sm:p-6 sm:pb-[calc(var(--app-tabbar-h)_+_1.5rem)] lg:pb-6">
          {children}
        </main>
      </div>
      <MobileTabBar />
    </div>
  );
};
